module.exports = __webpack_public_path__ + "img/pg.bd62bcf4.svg";